import * as React from 'react';
import {
    WrappedFieldProps
} from "redux-form";
import FormGroupRadioButton from "./form_group_radio_button";

interface IProps {
    label: string;
    type: string;
}

const FormGroupRadioButtonConnectRf: React.FC<IProps & WrappedFieldProps> = (props) => {

    const { label, input, meta, type} = props;

    const hasError = !!meta.error && !!meta.touched;

    return (
        <FormGroupRadioButton
            name={input.name}
            label={label}
            input={input}
            hasError={hasError}
            type={type}
            errorText={props.meta.error}
        />
    );
};

export default (FormGroupRadioButtonConnectRf);


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_radio_button_connect_rf.tsx